<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useInitializeStore } from '@/stores/initialize';
import LiveCourt from '@/components/live_sports/LiveCourt.vue';

/**
 * Renders the live court, which carries Virtual Live and the video stream.
 *
 * Only meaningful beside a live fixture, so it renders nothing outside the live
 * sports routes. Up to 1280px the fixture book renders the court instead, so the
 * sidebar leaves it out, as it did before the placement existed.
 */
defineProps({
	widget: { type: Object, required: true },
});

const route = useRoute();
const initializeStore = useInitializeStore();

const isLiveSportsRoute = computed(() => {
	return (
		(route.name || '').toString().startsWith('live-sports') ||
		(route.name || '').toString().startsWith('esports-live') ||
		(route.name || '').toString().startsWith('esports-all-live') ||
		(route.name || '').toString().startsWith('live-Esports-eventview')
	);
});

const shouldRender = computed(() => isLiveSportsRoute.value && initializeStore.screenWidth > 1280);
</script>

<template>
	<div v-if="shouldRender" class="marketing-virtual-live">
		<LiveCourt />
	</div>
</template>

<style scoped>
.marketing-virtual-live {
	width: 100%;
}
</style>
